// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav li > a.notificationCount:hover {
  color: white;
}

.notificationCount{
  color: white;
  background-color: #FF6600;
  width: 35px;
  padding: 0px;
  padding-top: 2px;
  height: 24px;
  margin-top: 13px;
  border-radius: 5px;
  padding-left: 9px;
  font-size: 15px;
  margin-left: 10px;
  cursor: pointer;
}

#footer{
    margin-top: 50px;
    background-color: rgba(0, 0, 0, 0.685);
    color: rgb(245, 244, 243);
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    bottom: 0px;
    width: 100%;
    left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: fixed; */
}

.privacy-policy { 
    position: absolute;
    right: 5%;
    color: white
}
h1 {
    margin-top:10px;
    margin-bottom: 10px;
}
.fill-remaining-space {
    /* This fills the remaining space, by using flexbox.
       Every toolbar row uses a flexbox row layout. */
    flex: 1 1 auto;
}
.top-toolbar {
    height:85px;
}

#dropdown-right {
    padding: 10px;
    margin-right: 200px;
}
#dropdown-right > li{
    padding:2px 2px;
    margin:3px 2px 3px 2px;
    border:none;
}
::ng-deep .mat-menu-content {
    background:  #f9f9f9 !important;
 }

.menu span {
    color:#337ab7 ;
}

.menu button:hover {
    background-color: rgb(176, 180, 182);
}
.sidenav-content {
    position:absolute;
    height:100%;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    height:100%;
    padding:10px;
}

.column {
    float: left;
    width: 10%;
    padding: 10px;
    align-items: center;
}

.column1 {
    float: left;
    width: 90%;
}

.row:after {
    content: "";
    display: table;
    clear: both;
}

.nav li.active > a {
    color:#EF673A;
}

.nav li > a:focus {
    background-color: transparent;
}
.nav li > a:hover {
    background-color: rgb(176, 180, 182);
}


.ql-editor {
    min-height: 0px !important;
    width: 98% !important;
    padding: 0px;
}

.ql-container {
    font-size: 15px !important;
}

.pointer.active.desc:after {
    content: " ▼";
    color: #390263;
}
.pointer.active.asc:after {
    content: " ▲";
    color: #02661d   
}


.nav li a {
    font-size: medium;
}

.nav li a:hover {
    border-radius: 15px;
    background: #fcfafa;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    margin-left: 2px;
    margin-right: 2px;
    transition: all 300ms cubic-bezier(.17,.67,.83,.67);
}


.navbar-nav > .active > a{
    border-radius: 15px;
    background: #F2F2F2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    margin-left: 2px;
    margin-right: 2px;
}

.mat-stroked-button {
    line-height: 55px;
    color:black
}

.mat-menu-panel {
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT;AACJ;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI;qDACiD;IACjD,cAAc;AAClB;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,+BAA+B;CAClC;;AAED;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,oCAAoC;AACxC;;;AAGA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,aAAa;IACb;AACJ;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;IACjB,mDAAmD;AACvD;;;AAGA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".nav li > a.notificationCount:hover {\n  color: white;\n}\n\n.notificationCount{\n  color: white;\n  background-color: #FF6600;\n  width: 35px;\n  padding: 0px;\n  padding-top: 2px;\n  height: 24px;\n  margin-top: 13px;\n  border-radius: 5px;\n  padding-left: 9px;\n  font-size: 15px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n#footer{\n    margin-top: 50px;\n    background-color: rgba(0, 0, 0, 0.685);\n    color: rgb(245, 244, 243);\n    font-size: 14px;\n    text-align: center;\n    line-height: 40px;\n    height: 40px;\n    bottom: 0px;\n    width: 100%;\n    left: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* position: fixed; */\n}\n\n.privacy-policy { \n    position: absolute;\n    right: 5%;\n    color: white\n}\nh1 {\n    margin-top:10px;\n    margin-bottom: 10px;\n}\n.fill-remaining-space {\n    /* This fills the remaining space, by using flexbox.\n       Every toolbar row uses a flexbox row layout. */\n    flex: 1 1 auto;\n}\n.top-toolbar {\n    height:85px;\n}\n\n#dropdown-right {\n    padding: 10px;\n    margin-right: 200px;\n}\n#dropdown-right > li{\n    padding:2px 2px;\n    margin:3px 2px 3px 2px;\n    border:none;\n}\n::ng-deep .mat-menu-content {\n    background:  #f9f9f9 !important;\n }\n\n.menu span {\n    color:#337ab7 ;\n}\n\n.menu button:hover {\n    background-color: rgb(176, 180, 182);\n}\n.sidenav-content {\n    position:absolute;\n    height:100%;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    height:100%;\n    padding:10px;\n}\n\n.column {\n    float: left;\n    width: 10%;\n    padding: 10px;\n    align-items: center;\n}\n\n.column1 {\n    float: left;\n    width: 90%;\n}\n\n.row:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n\n.nav li.active > a {\n    color:#EF673A;\n}\n\n.nav li > a:focus {\n    background-color: transparent;\n}\n.nav li > a:hover {\n    background-color: rgb(176, 180, 182);\n}\n\n\n.ql-editor {\n    min-height: 0px !important;\n    width: 98% !important;\n    padding: 0px;\n}\n\n.ql-container {\n    font-size: 15px !important;\n}\n\n.pointer.active.desc:after {\n    content: \" ▼\";\n    color: #390263;\n}\n.pointer.active.asc:after {\n    content: \" ▲\";\n    color: #02661d   \n}\n\n\n.nav li a {\n    font-size: medium;\n}\n\n.nav li a:hover {\n    border-radius: 15px;\n    background: #fcfafa;\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n    margin-left: 2px;\n    margin-right: 2px;\n    transition: all 300ms cubic-bezier(.17,.67,.83,.67);\n}\n\n\n.navbar-nav > .active > a{\n    border-radius: 15px;\n    background: #F2F2F2;\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n    margin-left: 2px;\n    margin-right: 2px;\n}\n\n.mat-stroked-button {\n    line-height: 55px;\n    color:black\n}\n\n.mat-menu-panel {\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
